class FunctionTimer {
  constructor(callback, initialFrequency) {
    this.callback         = callback;
    this.initialFrequency = initialFrequency;
    this.frequency        = initialFrequency;
  }

  ChangeSpeed(newFrequency) { 
    this.Stop();
    this.frequency = newFrequency;
    this.Start();
  }

  Start() { 
    this.intervalId = setInterval(this.callback, this.frequency);
  }

  Stop() {
    clearInterval(this.intervalId);
  }

  Reset() {
    this.Stop();
    this.frequency = this.initialFrequency;
  }
}

export default FunctionTimer